module.exports = __webpack_public_path__ + "static/img/50.659fdc52.jpg";